import { SingleDataValue } from '../data-display';
import { ThemedFlex } from '../../theme/ThemedFlex';

export const ResourceTileWiki = ({ animate }) => {

  return (
    <ThemedFlex
      direction="column"
      mb="12px"
      py="18px"
      px="20px"
      flex={1}
      borderRadius={3}
      className={animate ? 'gray-border-custom gray-border' : ''}
    >
      <SingleDataValue
        label="Established 2010"
        value="Bitcoin Wiki"
        link="https://en.bitcoin.it/wiki/Main_Page"
      />
    </ThemedFlex>
  );
};
